import React from 'react';
import { observer } from 'mobx-react-lite';
import cc from 'classcat';
import styles from './shipCard.module.sass';
import { Icon } from '../../../../Icon';
import { Badge } from '../../../../Badge';
import { declOfNum } from '../../../../../utils/declOfNum';
import { Anchor } from '../../../../Text';
import { IconSVG } from '../../../../SpriteSVG';
import { yandexDataLayer } from '../../../../../lib/yandexDataLayer';

const categories = {
  1: {
    classCategoryReady: 'eco',
    title: 'Эконом',
  },
  2: {
    classCategoryReady: 'standart',
    title: 'Стандарт',
  },
  3: {
    classCategoryReady: 'comfort',
    title: 'Комфорт',
  },
  6: {
    classCategoryReady: 'lux',
    title: 'Люкс',
  },
  7: {
    classCategoryReady: 'premium',
    title: 'Премиум',
  },
};

export const ShipCard = observer(
  ({
    shipInfo,
    position,
    title = '',
    url,
    places,
    category,
    viewed,
    image,
    countDesc,
    peoples_count,
    cauta_count,
    construction_date,
    restoration_date,
    type,
    isMobile,
  }) => {
    const href = `/ships/${url}`;
    const isSea = type === 'sea';

    return (
      <div className={styles.wrapper}>
        <div>
          <a className={styles.main}>
            <header className={styles.header}>{title || '-'}</header>
            <div className={styles.pic}>
              <a
                href={href}
                style={{ display: 'flex', height: '100%' }}
                className={cc({ [styles.blackout]: viewed })}
                rel="nofollow noreferrer"
                onClick={() => {
                  yandexDataLayer('click', {
                    id: shipInfo.id,
                    name: shipInfo.name,
                    brand: shipInfo.company || '',
                    category: shipInfo.class.lable,
                    position: position + 1,
                    quantity: 1,
                  });
                }}
              >
                {(image && (
                  <img
                    src={`/${image}`}
                    alt={`Теплоход ${title}`}
                    title={`Теплоход ${title}`}
                    loading="lazy"
                  />
                )) || (
                  <Icon
                    icon={
                      <IconSVG
                        name={'common/ships-plug'}
                        width={400}
                        height={172}
                        alt={title}
                      />
                    }
                    alt={title}
                    loading="lazy"
                  />
                )}
              </a>
              <div className={styles.badges}>
                <Badge
                  size="smUltra"
                  view={categories[category.value]?.classCategoryReady}
                  icon={categories[category.value]?.classCategoryReady}
                >
                  {category.lable}
                </Badge>

                {places > 0 && places < 25 && (
                  <Badge view="hot" size="smUltra" icon={'fire'}>
                    {`Осталось ${places}
                    ${declOfNum(places, ['каюта', 'каюты', 'кают'])}`}
                  </Badge>
                )}
                <Badge view="luxSolid" size="smUltra">
                  {countDesc}{' '}
                  {declOfNum(countDesc, ['палуба', 'палубы', 'палуб'])}
                </Badge>
              </div>
            </div>
            <div className={styles.body}>
              {restoration_date !== 0 && (
                <div className={styles.year}>
                  <span>{`Реновация ${restoration_date} `}</span>
                  {`Год постройки ${construction_date}`}
                </div>
              )}
              <div className={styles.bonus}>
                <Icon
                  icon={
                    <IconSVG
                      name={'promo/caute_count'}
                      width={24}
                      height={24}
                    />
                  }
                  rightGap={8}
                  title="Иконка кэшбека"
                />
                <p>Общее количество кают: {cauta_count}</p>
              </div>
              <div className={styles.bonus}>
                <Icon
                  icon={
                    <IconSVG name={'promo/seat_count'} width={24} height={24} />
                  }
                  rightGap={8}
                  title="Иконка кэшбека"
                />
                <p>Вместимость (человек): {peoples_count}</p>
              </div>
            </div>
          </a>
        </div>

        <footer className={styles.footer}>
          <Anchor
            decoration="none"
            className={styles.shipButton}
            href={`/ships/${url}`}
          >
            <div className={styles.btn}>Подробнее о корабле и круизах</div>
          </Anchor>
          {!isSea && (
            <Anchor
              decoration="none"
              variant="linkAsbuttonCashback"
              className={styles.shipButton}
              href={'/rent'}
            >
              <div className={styles.btnRent}>Аренда корабля</div>
            </Anchor>
          )}
        </footer>
      </div>
    );
  },
);
